import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.ready();

  if (authService.isAuthenticated()) {
    const currentUser = authService.getCurrentUser();
    const isOnboardingRoute = state.url.startsWith('/onboarding');

    if (currentUser && !currentUser.onboardingCompleted && !isOnboardingRoute) {
      return router.createUrlTree(['/onboarding']);
    }

    if (currentUser && currentUser.onboardingCompleted && isOnboardingRoute) {
      return router.createUrlTree(['/sessions']);
    }

    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
